import React from 'react';
import SubjectPage from '../structure/SubjectPage';

const DBMS_AI = ({ branch = "AIML", semester = "4th Semester" }) => {
  const accordionContent = [
    <div key="1" className="p-4">
      <p>Introduction-Overview of Database System and various Data Models (Hierarchical,
        Network, and Relational Models), Views of Data, Comparison of Database Management
        System with File System, Architecture of DBMS, components of DBMS. Data
        Independence. Entity-Relationship Model- Entities, Entity Types, Attributes, Relationships,
        Relationship types, E/R diagram notation, Conversion of E/R diagram to relations.</p>
    </div>,
    <div key="2" className="p-4">
      <p>Relational Data Model- Concept of Relations, Overview of Various Keys, Referential
        Integrity, and foreign keys. Relational Language- Relational Algebra, Tuple and Domain
        Relational Calculus, SQL, DDL and DML, Introduction and basic concepts of PL/SQL
        (Cursors, Procedures, Triggers). Basic steps in Query Processing and Optimization.</p>
    </div>,
    <div key="3" className="p-4">
      <p>Database Design- Dependencies and Normal forms, Functional Dependencies, 1NF, 2NF,
        3NF, and BCNF. Higher Normal Forms-4NF and 5NF. Transaction Management: ACID
        properties, Serializability, Concurrency Control (2PL, Timestamp protocol), Database
        recovery management – Log based recovery, checkpoints.</p>
    </div>,
    <div key="4" className="p-4">
      <p>Advanced Topics- CAP Theorem, Data Storage and Indexes, Hashing Techniques, NOSql,
        Types of NOSql databases, MongoDB: Introduction, History of MongoDB, Installation and
        configuration. Key Features. Core servers & tools. Basic commands, Comparison of
        relational databases to MongoDB, Cassendra, HBASE, etc.</p>
    </div>
  ];

  const tabData = [
    {
      id: 'syllabus',
      label: 'Syllabus',
      content: null, // Will be replaced in SubjectPage
    },
    {
      id: 'notes',
      label: 'Notes',
      content: null, // Will be replaced in SubjectPage
    },
    {
      id: 'important',
      label: 'Important Questions',
      content: null, // Will be replaced in SubjectPage
    },
    {
      id: 'books',
      label: 'Books',
      content: null, // Will be replaced in SubjectPage
    },
    {
      id: 'PYQ',
      label: 'PYQ',
      content: null, // Will be replaced in SubjectPage
    },
    {
      id: 'youtube_playlist',
      label: 'Video Lectures',
      content: null, // Will be replaced in SubjectPage
    },
  ];

  return (
    <SubjectPage
      subjectName="Database Management Systems"
      subjectKey="AI_DBMS"
      branch={branch}
      semester={semester}
      accordionContent={accordionContent}
      tabData={tabData}
      adminEmail="snaped4338@gmail.com"
      firestoreCollections={{
        notes: 'AIDBMSNotes',
        videos: 'AIDBMSVideos'
      }}
    />
  );
};

export default DBMS_AI;